import { makeFieldStyleSelector, makeFormButtonsStyleSelector } from "@client/content/modules/selectors";
import { makeButtonStyleSelector } from "@client/content/Providers/FormStyle/selectors";
import { type RootContainerProps } from "@client/content/types";
import { connectCustom } from "@client/lib/misc";
import {
  combinedSettingsSelector,
  getSettingValueSelector,
  makeTextStyleSelector,
  TargetSelector
} from "@client/selectors";
import { type AppState, type EntityRef } from "@client/types";
import Component, { type MapProps } from "./component";

export type Props = RootContainerProps;
const makeMapStateToProps = () => {
  const fieldStyleSelector = makeFieldStyleSelector(TargetSelector.Layout, "floatingMenu.popup");
  const buttonStyleSelector = makeButtonStyleSelector(TargetSelector.Layout, "floatingMenu.popup.button");
  const buttonCaptionSelector = getSettingValueSelector(TargetSelector.Layout, "caption", "floatingMenu.popup.button");
  const formButtonsStyleSelector = makeFormButtonsStyleSelector(TargetSelector.Layout, "floatingMenu.popup.button");
  const buttonsAlignSelector = getSettingValueSelector(
    TargetSelector.Layout,
    "innerHorizontalAlign",
    "floatingMenu.popup.button"
  );
  const labelStyleSelector = makeTextStyleSelector(TargetSelector.Layout, "floatingMenu.popup.label");

  const settingsSelector = combinedSettingsSelector(
    TargetSelector.Layout,
    [
      { name: "placement", prop: "labelPlacement" },
      { name: "visibility", prop: "labelVisibility" }
    ],
    "floatingMenu.popup.label"
  );

  return (state: AppState, props: Props): MapProps => {
    const { labelPlacement, labelVisibility } = settingsSelector(state, props);
    const selectorArgs: EntityRef = { id: "", source: "content" }; // TODO: get rid of fake id

    return {
      ...props,
      buttonsAlign: buttonsAlignSelector(state, selectorArgs),
      buttonCaption: buttonCaptionSelector(state, selectorArgs),
      buttonsStyle: formButtonsStyleSelector(state, selectorArgs),
      fieldStyle: fieldStyleSelector(state, selectorArgs),
      labelPlacement,
      labelVisibility,
      labelStyle: labelStyleSelector(state, selectorArgs),
      portalId: state.portal.id,
      primaryButtonStyle: buttonStyleSelector(state, selectorArgs)
    };
  };
};

export default connectCustom(makeMapStateToProps)(Component);
